import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useRouteMatch } from 'react-router-dom';
import LinearProgress from '@material-ui/core/LinearProgress';
import CoursesActions from '../../../Redux/CoursesRedux';
import NoMatch404 from '../../NoMatch404';
import CourseManage from '../../../Components/Shared/Courses/CourseManage';

const LeagueCourseManage = () => {
  const dispatch = useDispatch();
  const match = useRouteMatch();
  const { league_id: leagueId, course_slug: courseSlug } = match.params;

  const course = useSelector(state => state.courses.course);
  const isFetching = useSelector(state => state.courses.isFetching.getLeagueCourse);
  const errors = useSelector(state => state.courses.errors.getLeagueCourse);

  React.useEffect(() => {
    if (leagueId && courseSlug) {
      dispatch(CoursesActions.getLeagueCourseRequest(leagueId, courseSlug));
    }
  }, [leagueId, courseSlug, dispatch]);

  const onEditCourse = (event, course, cover, attachments) => {
    event.preventDefault();
    dispatch(CoursesActions.updateLeagueCourseRequest(leagueId, course, cover, attachments));
  };

  const onCreateUnit = (event, unit) => {
    event.preventDefault();
    dispatch(CoursesActions.createLeagueCourseUnitRequest(leagueId, course.slug, unit));
  };

  const onEditUnit = (event, unit) => {
    event.preventDefault();
    dispatch(CoursesActions.updateLeagueCourseUnitRequest(leagueId, course.slug, unit));
  };

  const onDeleteUnit = unit => {
    dispatch(CoursesActions.destroyLeagueCourseUnitRequest(leagueId, course.slug, unit.id));
  };

  const onCreateChapter = (event, chapter) => {
    event.preventDefault();
    dispatch(CoursesActions.createLeagueCourseChapterRequest(leagueId, course.slug, chapter));
  };

  const onDeleteChapter = chapterId => {
    dispatch(CoursesActions.destroyLeagueCourseChapterRequest(leagueId, course.slug, chapterId));
  };

  const onEditChaptersOrder = unitAttributes => {
    dispatch(CoursesActions.updateLeagueCourseUnitRequest(leagueId, courseSlug, unitAttributes));
  };

  return (
    <>
      {isFetching && <LinearProgress />}
      {!isFetching && course && `${courseSlug}` === `${course.slug}` && (
        <CourseManage
          course={course}
          functions={{
            onEditCourse,
            onCreateUnit,
            onEditUnit,
            onDeleteUnit,
            onCreateChapter,
            onDeleteChapter,
            onEditChaptersOrder,
          }}
        />
      )}
      {!isFetching && errors?.status === 404 && <NoMatch404 />}
    </>
  );
};

export default LeagueCourseManage;
